<!-- WaveSpinner

This implements the "Wave" spinner from SpinKit.
CSS/HTML copied from https://github.com/tobiasahlin/SpinKit

Usage:
  // A "block" spinner, with margin
  <WaveSpinner/>

  // An inline spinner
  <WaveSpinner inline/>

-->
<template>
  <div class="sk-wave" :class="{inline: inline, block: !inline}">
    <div class="sk-rect sk-rect1" :style="{backgroundColor: color}"></div>
    <div class="sk-rect sk-rect2" :style="{backgroundColor: color}"></div>
    <div class="sk-rect sk-rect3" :style="{backgroundColor: color}"></div>
    <div class="sk-rect sk-rect4" :style="{backgroundColor: color}"></div>
    <div class="sk-rect sk-rect5" :style="{backgroundColor: color}"></div>
  </div>
</template>
<script>
export default {
  props: {
    inline: Boolean,
    color: String
  }
}
</script>
<style scoped>
.inline {
  display: inline-block;
  vertical-align: middle;
}
.block {
  margin: 40px auto;
}
.sk-wave {
  height: 20px;
  font-size: 10px;
  width: 50px;
  text-align: center;
}
.sk-wave .sk-rect {
    background-color: #333;
    height: 100%;
    width: 6px;
    display: inline-block;
    -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;
            animation: sk-waveStretchDelay 1.2s infinite ease-in-out; }
  .sk-wave .sk-rect1 {
    -webkit-animation-delay: -1.2s;
            animation-delay: -1.2s; }
  .sk-wave .sk-rect2 {
    -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s; }
  .sk-wave .sk-rect3 {
    -webkit-animation-delay: -1s;
            animation-delay: -1s; }
  .sk-wave .sk-rect4 {
    -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s; }
  .sk-wave .sk-rect5 {
    -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s; }

@-webkit-keyframes sk-waveStretchDelay {
  0%, 40%, 100% {
    -webkit-transform: scaleY(1);
            transform: scaleY(1); }
  20% {
    -webkit-transform: scaleY(1.6);
            transform: scaleY(1.6); } }

@keyframes sk-waveStretchDelay {
  0%, 40%, 100% {
    -webkit-transform: scaleY(1);
            transform: scaleY(1); }
  20% {
    -webkit-transform: scaleY(1.6);
            transform: scaleY(1.6); } }
</style>



// WEBPACK FOOTER //
// src/components/shared/WaveSpinner.vue